import { useLocation, useNavigate } from 'react-router-dom'
import { Bell } from 'lucide-react'
import { useEffect, useState } from 'react'
import { ROUTES } from '../../lib/constants'
import { formatDate } from '../../lib/utils'
import { supabase } from '../../lib/supabase'
import { useAuth } from '../../hooks/useAuth'
import styles from './TopBar.module.css'

const PAGE_TITLES = {
  [ROUTES.DASHBOARD]:    'Dashboard',
  [ROUTES.PRODUCTS]:     'Products',
  [ROUTES.PREDICTIONS]:  'Predictions',
  [ROUTES.SUPPLIERS]:    'Suppliers',
  [ROUTES.EMAIL_DRAFTS]: 'Email Drafts',
  [ROUTES.ALERTS]:       'Alerts',
  [ROUTES.SETTINGS]:     'Settings',
}

export default function TopBar() {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { user } = useAuth()
  const [unreadCount, setUnreadCount] = useState(0)

  const title = PAGE_TITLES[pathname] || 'Debnix'
  const today = formatDate(new Date(), { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })

  useEffect(() => {
    if (user) fetchUnreadCount()
  }, [user, pathname])

  async function fetchUnreadCount() {
    try {
      const { count } = await supabase
        .from('alerts')
        .select('*', { count: 'exact', head: true })
        .eq('user_id', user.id)
        .eq('is_read', false)
      setUnreadCount(count || 0)
    } catch (err) {
      console.error('Failed to fetch unread count:', err)
    }
  }

  function handleBellClick() {
    navigate(ROUTES.ALERTS)
  }

  return (
    <header className={styles.topbar}>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.right}>
        <span className={styles.date}>{today}</span>
        <button
          className={styles.notifBtn}
          title="Notifications"
          onClick={handleBellClick}
        >
          <Bell size={18} />
          {unreadCount > 0 && (
            <span className={styles.badge}>
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          )}
        </button>
      </div>
    </header>
  )
}